import { definePreset } from '@primeuix/themes';
import Lara from '@primeuix/themes/lara';

// PrimeNG 17'deki "lara-light-blue" CSS temasinin karsiligi: Lara preset'i + mavi primary paleti.
export const CgatePrimeNgPreset = definePreset(Lara, {
  semantic: {
    primary: {
      50: '{blue.50}',
      100: '{blue.100}',
      200: '{blue.200}',
      300: '{blue.300}',
      400: '{blue.400}',
      500: '{blue.500}',
      600: '{blue.600}',
      700: '{blue.700}',
      800: '{blue.800}',
      900: '{blue.900}',
      950: '{blue.950}',
    },
  },
});

// Eski tema her zaman acikti; PrimeNG 18+ varsayilan olarak OS koyu modunu izler. Bu sinif hicbir yerde
// uygulanmadigi icin PrimeNG bilesenleri acik temada kalir (koyu mod Metronic tarafindan yonetiliyor).
export const PRIMENG_DARK_MODE_SELECTOR = '.cg-primeng-dark-mode';
